<template>
    <b-container 
        class="bv-example-row" 
        style="margin-bottom: 64px; min-height: 50vh"
    >
        <b-row class="mt-4">
            <b-col>
                <h3>{{ `Verify Device` }}</h3>
            </b-col>
        </b-row>

        <b-row class="my-3" style="width: 320px; margin: auto;">
            <b-col style="width:200px">
                <h5> 
                    Selected Device: <br/>
                    {{ imei }}
                </h5>


            </b-col>
        </b-row>

        <b-row class="my-3">
            <b-col>
                <qrcode-stream @decode="onDecode" style="width:80%; margin:auto"></qrcode-stream>
            </b-col>
        </b-row>

        <b-row class="mb-2" style="text-align:center">
            <b-col >
                 <b-button 
                    block 
                    variant="success"
                    style="width:60%; margin:auto; height: 48px; padding-top: 11px"
                    :disabled="!selected_device" 
                    :to="`/verify/${selected_device ? selected_device.imei : null}`"
                > Continue </b-button>
              <br/>
              <b-btn block
                     class="mb-5"
                     variant="light"
                     style="width:60%; margin:auto; height: 48px; padding-top: 11px"
                     @click="cancelSelfInstall()">Cancel Installation</b-btn>
                     <b-row class="mb-2" style="text-align:center">
            <b-col >
            </b-col>
        </b-row>

            </b-col>
        </b-row>
        <b-row class="mt-5">
            <b-col>
                <h5> 
                    <strong>HINT:</strong> Generate a device with value: <br/>
                    <strong>{{ 
                        available_devices.length 
                            ? available_devices[0].text
                            : null
                    }}</strong>
                </h5>
                <b-link href="https://www.the-qrcode-generator.com/">QR Code Generator</b-link>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>

    import deviceApi from '../../device_apis'
    import SearchSelect from '../../widgets/SearchSelect'
    import { QrcodeStream } from 'vue-qrcode-reader'

    export default {
        name: 'SelectDevice',
        components: { 
            SearchSelect,
            QrcodeStream
        },

        props:{
            userData:{ type: Object, required: true }
        },        

        data(){
            return {
                selected_device: null,
                available_devices: [],

                imei: ''
            }
        },


        methods:{
            onDecode (decodedString) {
                this.imei = decodedString
                this.findDevice()
                console.log('Decoded String', decodedString)
            },
            async findDevice() {
                this.items = []
                this.selected_device = null
                this.available_devices = []
                try {
                    const deviceFound = await deviceApi.searchDevices({
                        search_string: this.imei,
                        device_type: null,
                        device_status: null,
                        install_status: "ready",
                    })
                    if (deviceFound.status_code === 200) {
                        this.$emit('showAlert', 'Found device', 'success', 2100)
                    }
                    if (deviceFound.data.length === 0) {
                        this.$emit('showAlert', 'Device not found', 'danger', 5000)
                    }
                    this.items = deviceFound.data
                    this.itemsNotEmpty = true
                    this.totalRows = this.items.length
                    this.currentPage = 1

                    if (this.totalRows == 1) {
                        this.selected_device = this.items[0]
                        this.available_devices = deviceFound.data
                    }
                } catch (e) {
                    e.response && e.response.data && e.response.data.message
                        ? this.$emit('showAlert', e.response.data.message, 'danger', 5000)
                        : this.$emit('showAlert', 'Found more than one device, try again', danger, 5000)
                }
            },
            cancelSelfInstall(){
                localStorage.clear()
                window.location.replace("http://konametrix.com")
            },

        }
    }

</script>

<style/>
